module.exports = __webpack_public_path__ + "static/media/Vintage_4_t.fcf03b8c.jpg";